import * as React from "react"
import Button from "@mui/material/Button"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import { debounce } from "lodash"

import { t } from "@lingui/macro"

import { observer } from "mobx-react"

import { useStore } from "src/store/lib/useStore"
import { GlobalStore } from "src/store"
import { IConfirmResetTOTPModalProps } from "src/types/confirm-reset-totp-modal"

export const ConfirmResetTOTPModal = observer(
    (props: IConfirmResetTOTPModalProps) => {
        const { title, content } = props
        const gstore = useStore(GlobalStore)

        const handleClose = () => {
            gstore.modals.pop()
        }

        const handleReset = debounce(() => {
            props.resetTOTP()
        }, 500)

        return (
            <>
                <DialogTitle id="alert-dialog-title">
                    {title ?? t`confirm-reset-totp-modal.default-title`}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content ?? t`confirm-reset-totp-modal.default-content`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    style={{
                        justifyContent: "flex-start",
                        paddingLeft: "24px",
                    }}
                >
                    <Button color="info" onClick={handleClose}>
                        {t`confirm-reset-totp-modal.cancel`}
                    </Button>
                    <Button
                        data-testid="Reset-TOTP-button"
                        color="error"
                        onClick={handleReset}
                        autoFocus
                    >
                        {t`confirm-reset-totp-modal.reset`}
                    </Button>
                </DialogActions>
            </>
        )
    },
)
